export default __webpack_public_path__ + "static/media/181.810b747f.png";